<div>
  <div>

    <div class="tn-header">
      <header id="header">
        <div class="row center-block top-nav ">
          <div class="col-lg-8 logo col-md-8 col-sm-8 col-xs-12 columns title">
            <a href="#">
              <img src="../../assets/BWC-ER-Logo.png" alt=" State of Tennessee" id="entity-name"
                data-pin-nopin="true">
            </a>
          </div>

          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 columns text-right">

          </div>
        </div>

        <div class="backdrop" style="background-image:url('../../assets/test.jpg')"></div>
        <div class="backdrop-color"></div>
      </header>
    </div>





  </div>

</div>
